import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toogleEdit } from '../../../Utils/editMantraSlice';
import HTMLReactParser from "html-react-parser";
import { toogleReload } from '../../../Utils/reloadSlice';

const Mantras = ({data, setEditMantraValue}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const handleDelete = (id) => {
    setLoading(true);
    console.log(id);
    const deleteUrl = `https://api.mokx.org/api/v1/mantras/${id}`;
    // Create a DELETE request
    fetch(deleteUrl, {
      method: 'DELETE',
    })
    .then((response) => {
      if (response.ok) {
        alert('Mantra deleted successfully');
        dispatch(toogleReload());
      } else {
        console.error('Failed to delete resource');
      }
    })
    .catch((error) => {
      // Handle network errors
      console.error('Network error:', error);
    });
    setLoading(false);
  }

  const handleEdit = async (id) => {
    setLoading(true);
    const getData = await fetch(`https://api.mokx.org/api/v1/mantras/${id}`);
    const json = await getData.json();
    setEditMantraValue(json.data.mantra);
    setTimeout(() => {
      dispatch(toogleEdit());
    }, 500)
    setLoading(false);
  }

  const content = data.summary;

  return (
    <div key={data.id} className="relative lg:w-[48%] md:w-[48%] w-[100%] bg-[#FFF] rounded-xl drop-shadow-3Xl py-7 pr-9 pl-10 mb-4 flex flex-col justify-center gap-4" onMouseLeave={() => setVisible(false)}>
        {data.category && <div className='font-thin text-xs mb-[-10px]'><span className='font-medium'>Category:</span> {data.category}</div>}
        <div className='flex items-center gap-5 mb-4'>
          {data.images && <button onMouseEnter={() => setVisible(true)}>
            <img className='w-[30px] h-[30px]' src={`https://res.cloudinary.com/ddbrxrvat/image/upload/v1699305683/images/${data.images}`} alt="" />
          </button>}
          <h1 className='text-[#000] text-2xl font-figtree font-semibold'>{data.name}</h1>
        </div>
        <div className='line-clamp-5'>
            {HTMLReactParser(content)}
        </div>
        <div className='absolute right-1 top-1 cursor-pointer flex gap-1'>
          <button disabled={loading} onClick={() => handleEdit(data.id)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
              <path fill={loading? "#86B0F4":"#286de0"} d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2m3.1 5.07c.14 0 .28.05.4.16l1.27 1.27c.23.22.23.57 0 .78l-1 1l-2.05-2.05l1-1c.1-.11.24-.16.38-.16m-1.97 1.74l2.06 2.06l-6.06 6.06H7.07v-2.06l6.06-6.06Z"/>
            </svg>
          </button>
          <button disabled={loading} onClick={() => handleDelete(data.id)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
              <path fill={loading? "#FB9883":"#E23712"} d="M12 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S2 17.53 2 12S6.47 2 12 2m5 5h-2.5l-1-1h-3l-1 1H7v2h10V7M9 18h6a1 1 0 0 0 1-1v-7H8v7a1 1 0 0 0 1 1Z"/>
            </svg>
          </button>
        </div>
        {visible && <>
          <div className='w-full h-full fixed z-20 top-2.5 left-0 right-0 flex justify-center'>
            <img className='w-60 h-60' src={`https://res.cloudinary.com/ddbrxrvat/image/upload/v1699305683/images/${data.images}`} alt='' />
          </div>
          <div className='w-full h-full z-10 fixed top-0 left-0 right-0 bottom-0 rounded-xl bg-[#282c3f]/[0.5]' />
        </>}
    </div>
  )
}

export default Mantras;